/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReportFlowContainer_settings = {
    readonly " $fragmentRefs": FragmentRefs<"ReportCommentFormContainer_settings">;
    readonly " $refType": "ReportFlowContainer_settings";
};
export type ReportFlowContainer_settings$data = ReportFlowContainer_settings;
export type ReportFlowContainer_settings$key = {
    readonly " $data"?: ReportFlowContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"ReportFlowContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportFlowContainer_settings",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReportCommentFormContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '881b0d8df6b106a0c4a35a6a87d66d5c';
export default node;
